import ClientList from 'components/ClientList/ClientList';
import ClientCard from 'components/ClientCard/ClientCard';
import Pagination from 'components/Pagination/Pagination';
import useClientsSearch, { ClientSortLabel } from 'functions/hooks/useClientsSearch';
import CircularProgress from '@mui/material/CircularProgress';
import FilterNavigation from 'components/FilterNavigation/FilterNavigation';
import { agentClientsFilters } from 'pages/Agent/navigation';
import { clientSortOptions } from 'pages/Agent/menuLinks';
import { useEffect, useState } from 'react';
import { useAppSettings } from 'context/appsettingsContext';
import { useAuth } from 'context/useAuth';

export default function AllClients() {
  const settings = useAppSettings();
  const { authorisedUser, logout, firebaseAuth } = useAuth();
  const [submittedQuery, setSubmittedQuery] = useState('');
  const [sort, setSort] = useState<ClientSortLabel>('Latest');

  const {
    users,
    loading,
    error,
    pageIndex,
    hasNext,
    hasPrev,
    next,
    prev,
  } = useClientsSearch({ query: submittedQuery, sort, pageSize: 10 });

  useEffect(() => {
    (async () => {
      await firebaseAuth?.currentUser?.getIdToken(true);
    })();
  }, [authorisedUser, logout, settings.baseURL, firebaseAuth]);

  return (
    <>
      <FilterNavigation
        filters={agentClientsFilters}
        sortOptions={clientSortOptions}
        searchMode='submit'
        searchButtonLabel='Search'
        hideExtraOnMobile
        onSearchSubmit={(text) => setSubmittedQuery(text)}
        onSortChange={(label) => setSort(label as ClientSortLabel)}
      />
      <ClientList>
        {loading && (
          <div className='client-list__loader'>
            <CircularProgress />
          </div>
        )}
        {!loading && error && (
          <div className='client-list__error' role='alert'>
            {error}
          </div>
        )}
        {!loading &&
          !error &&
          users.map((user) => (
            <ClientCard
              key={user.id}
              clientData={{
                firstName: user.firstName,
                id: user.id,
                lastName: user.lastName,
                tamperActive: user.tamperActive,
              }}
            />
          ))}
      </ClientList>
      {!loading && !error && (
        <Pagination
          pageIndex={pageIndex}
          hasPrev={hasPrev}
          hasNext={hasNext}
          onPrev={prev}
          onNext={next}
        />
      )}
    </>
  );
}